<!--<mat-toolbar color="primary">
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
    <span>Menu</span>
    <button class="transparentButton">
      <mat-icon aria-hidden="false" aria-label="logout" (click)="firebaseService.logout()">logout</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav fxLayout="row" fxLayoutAlign="start start"  #drawer class="sidenav" fixedInViewport
             [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
             [mode]="(isHandset$ | async) ? 'over' : 'side'"
             [opened]="(isHandset$ | async) === false">

  <mat-nav-list>
    <a mat-list-item [routerLink]="['/home']">Home</a>

  </mat-nav-list>
</mat-sidenav>-->


<mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="space-between center">



  <img src="assets/img/logo-plvbroker.svg" alt="">

  <mat-form-field  *ngFor="let group of sharedService.groupsArray">
    <mat-label>{{'devices' | translation}}</mat-label>
    <mat-select>
      <mat-option *ngFor="let device of sharedService.devicesArray" [value]="device.data.name" (click)="sharedService.setActiveBorne(device)">
          {{device.data.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <section fxLayout="row" fxLayout="center center">
      <button (click)="openDialog()" mat-icon-button ><mat-icon>logout</mat-icon></button>
    <p>    {{firebaseService.user.displayName}}</p>
  </section>

</mat-toolbar>





<!-- <ol>
  <li>
    <mat-form-field>
      <input matInput [(ngModel)]="name" placeholder="What's your name?">
    </mat-form-field>
  </li>
  <li>
    <button mat-raised-button (click)="openDialog()">Pick one</button>
  </li>
  <li *ngIf="animal">
    You chose: <i>{{animal}}</i>
  </li>
</ol>

 -->
